export const getCookie = (cname) => {
  let name = cname + '=';
  let cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i++) {
    let cookieItem = cookieArr[i].trim();
    if (cookieItem.indexOf(name) === 0) return cookieItem.substring(name.length, cookieItem.length);
  }
  return '';
}
